webpackJsonp([6],{

/***/ "5uu+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Billing_vue__ = __webpack_require__("7+v1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_15a50b4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Billing_vue__ = __webpack_require__("n2xD");
function injectStyle (ssrContext) {
  __webpack_require__("6PXj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Billing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_15a50b4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Billing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6PXj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7+v1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common_vue__ = __webpack_require__("Uu/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_my_account_common_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_CommonBilling__ = __webpack_require__("vGe0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_my_account_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_file_saver__);











var billingService = __WEBPACK_IMPORTED_MODULE_2_CommonBilling__["a" /* ServiceContainer */].billingService;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'billing',
  components: {
    'date-range': __WEBPACK_IMPORTED_MODULE_2_CommonBilling__["b" /* dateRange */],
    'loading': __WEBPACK_IMPORTED_MODULE_2_CommonBilling__["c" /* loading */],
    'multi-select': __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a,
    'alert-banner': __WEBPACK_IMPORTED_MODULE_1_my_account_common_vue__["AlertBanner"]
  },
  data: function data() {
    return {
      timeZone: function () {
        var date = new Date();
        return -date.getTimezoneOffset();
      }(),
      showSpinner: false,
      isPrinting: false,
      dateErrors: [],
      datePickerStartDate: function () {
        var start = new Date();
        start.setMonth(start.getMonth() - 6);
        return start;
      }(),
      datePickerEndDate: new Date(),
      memberNumber: '',
      memberName: '',
      fooBar: '',
      columns: [{
        label: 'Member',
        field: 'memberName',
        sortable: true
      }, {
        label: 'Date',
        field: 'date',
        type: 'date',
        tdClass: 'text-center',
        thClass: 'text-center',
        html: '<span class="title" data-title="Date"></span>',
        sortable: true
      }, {
        label: 'Agreement',
        field: 'agreement',
        tdClass: 'text-center',
        thClass: 'text-center',
        sortable: true
      }, {
        label: 'Reference Number',
        field: 'referenceNumber',
        tdClass: 'text-center',
        thClass: 'text-center',
        sortable: true
      }, {
        label: 'Description',
        field: 'description',
        tdClass: 'text-center',
        thClass: 'text-center',
        sortable: true
      }, {
        label: 'Balance',
        field: 'numericBalance',
        type: 'decimal',
        tdClass: 'text-center',
        thClass: 'text-center',
        sortable: true
      }],
      rows: [],
      tfooter: {
        label: 'Total Balance:',
        value: '0.00'
      },
      billing: {
        memberFaoNames: [],
        masterMember: {},
        memberFaos: [],
        rowsPerPageText: 'Rows',
        nextText: '',
        prevText: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.showSpinner = true;
    this.executeFirstRequest().then(function () {
      _this.showSpinner = false;
      _this.billing.memberFaoNames = _this.billing.memberFaos.concat({
        'memberFullName': _this.memberName,
        'memberNumber': _this.memberNumber
      });
      _this.billing.memberFaoNames = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(_this.billing.memberFaoNames, function (row) {
        row.memberFullName = __WEBPACK_IMPORTED_MODULE_6_my_account_common__["StringUtils"].initCaps(row.memberFullName);
        return row;
      });
    }).catch(function (error) {
      _this.showSpinner = false;
      if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
        _this.$toasted.show('<p>' + error.response.data.errorMessage + '</p>', {
          position: 'bottom-center',
          duration: 10000
        });
      }
    });
  },

  methods: {
    testNewDate: function testNewDate() {
      if (typeof this.datePickerStartDate.getMonth === 'function') {
        return this.datePickerStartDate;
      }
      var start = new Date();
      start.setMonth(start.getMonth() - 5);
      return start;
    },
    executeFirstRequest: function executeFirstRequest() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.callSearchByDate(true).then(function (response) {
          _this2.setData(response.data);
          resolve();
        }).catch(function (error) {
          if (error.response !== undefined && error.response.status === 412) {
            _this2.datePickerStartDate = new Date(error.response.data.enrollmentDate);
            _this2.callSearchByDate(true).then(function (response) {
              _this2.setData(response.data);
              resolve();
            }).catch(function (secondError) {
              reject(secondError);
            });
          } else {
            reject(error);
          }
        });
      });
    },
    limitText: function limitText(count) {
      if (count === 1) {
        var start = this.billing.memberFaoNames[0].memberNumber === this.memberNumber ? '★ ' : '';
        start += this.billing.memberFaoNames[0].memberFullName;
        return start;
      }
      return 'Selected (' + count + ')';
    },
    searchByDateRangeUi: function searchByDateRangeUi(withCache) {
      this.$nextTick(function () {
        this.searchByDateRange(withCache);
      });
    },
    searchByDateRange: function searchByDateRange(withCache) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.showSpinner = true;
        _this3.callSearchByDate(withCache).then(function (response) {
          _this3.showSpinner = false;
          _this3.setData(response.data);
          resolve(response);
        }).catch(function (error) {
          _this3.showSpinner = false;
          if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
            _this3.$snackbar.create(error.response.data.errorMessage, {}, function () {});
          }
          reject(error);
        });
      });
    },
    callSearchByDate: function callSearchByDate(withCache) {
      return billingService.getBillingHistoryView({
        useCache: withCache,
        ttl: 10,
        params: {
          startDate: this.formatDate(this.datePickerStartDate),
          endDate: this.formatDate(this.datePickerEndDate),
          timezoneOffset: this.timeZone
        }
      });
    },
    dateRangeChanged: function dateRangeChanged(event) {
      this.datePickerStartDate = event.datePickerStartDate;
      this.datePickerEndDate = event.datePickerEndDate;
      this.dateErrors = event.errors;
    },
    formatDate: function formatDate(date) {
      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();
      return monthIndex + 1 + '/' + day + '/' + year;
    },
    printBilling: function printBilling() {
      var _this4 = this;

      var memberWithAgreements = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(this.billing.memberFaoNames, function (member) {
        return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.some(_this4.rows, function (row) {
          return row.memberNumber === member.memberNumber;
        });
      });
      if (memberWithAgreements.length === 0) {
        this.$snackbar.create('No members with agreements were selected ', {}, function () {});
        return;
      }
      this.isPrinting = true;
      var promises = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(memberWithAgreements, function (member) {
        return billingService.printBillingHistory({
          responseType: 'blob',
          params: {
            startDate: _this4.formatDate(_this4.datePickerStartDate),
            endDate: _this4.formatDate(_this4.datePickerEndDate),
            memberNumber: member.memberNumber,
            timezoneOffset: _this4.timeZone
          }
        }).then(function (success) {
          _this4.openFile(success, member.memberNumber);
        }).catch(function (error) {
          if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
            _this4.$snackbar.create(error.response.data.errorMessage, {}, function () {});
          } else {
            _this4.$snackbar.create('Could not print pdf', {}, function () {});
          }
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        _this4.isPrinting = false;
      }).catch(function () {
        _this4.isPrinting = false;
      });
    },
    openFile: function openFile(success, member) {
      var blob = success.data;
      __WEBPACK_IMPORTED_MODULE_7_file_saver___default.a.saveAs(blob, member + '-' + this.formatDateForFile(new Date()) + '.pdf');
    },
    formatDateForFile: function formatDateForFile(date) {
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var monthIndex = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      var year = date.getFullYear();
      return year + '' + monthIndex + '' + day;
    },
    setData: function setData(viewData) {
      this.rows = viewData.billingList;
      this.billing.memberFaos = viewData.faos;
      this.memberNumber = viewData.memberNumber;
      this.memberName = __WEBPACK_IMPORTED_MODULE_6_my_account_common__["StringUtils"].initCaps(viewData.memberName);
    }
  },
  computed: {
    filteredRows: {
      get: function get() {
        var _this5 = this;

        var filterResult = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(this.rows, function (row) {
          return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(_this5.billing.memberFaoNames, 'memberNumber'), row.memberNumber);
        });

        return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(filterResult, function (row) {
          var newRow = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(row);
          newRow.memberName = __WEBPACK_IMPORTED_MODULE_6_my_account_common__["StringUtils"].initCaps(newRow.memberName);
          newRow.numericBalance = newRow.balance;
          newRow.balance = '$' + newRow.balance;
          return newRow;
        });
      }
    },
    totalValue: {
      get: function get() {
        return '$' + __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sumBy(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(this.filteredRows, function (o) {
          return o.description.toLowerCase() !== 'refund';
        }), 'numericBalance').toFixed(2);
      }
    },
    allMembers: {
      get: function get() {
        var selectableMembers = this.billing.memberFaos.slice(0);
        return selectableMembers.concat({ memberNumber: this.memberNumber, memberFullName: this.memberName });
      }
    },
    selectAll: {
      get: function get() {
        return this.billing.memberFaos ? this.selected.length === __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.size(this.billing.memberFaos) : false;
      },
      set: function set(value) {
        var selected = [];

        if (value) {
          __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.forEach(this.billing.memberFaos, function (memberFao, key) {
            selected.push(memberFao.memberNumber);
          });
        }
        this.selected = selected;
      }
    }
  }
});

/***/ }),

/***/ "n2xD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-24",attrs:{"id":"billing"}},[_c('loading',{attrs:{"show":_vm.showSpinner,"label":"Loading...","overlay":true}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container billing-container"},[_c('div',{staticClass:"row billing-section"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row edit-form"},[_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-12 billing-about"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"billing-about-section materialized col-lg-6 col-md-6 col-sm-12 col-xs-12 "},[_c('div',{staticClass:"form-group materialized"},[_c('multi-select',{attrs:{"options":_vm.allMembers,"multiple":true,"searchable":false,"label":"memberFullName","id":"billing-members","disabled":_vm.allMembers.length < 2,"placeholder":"Select","track-by":"memberNumber","limit":0,"limit-text":_vm.limitText,"deselectLabel":"Remove","selectLabel":"Add","allowEmpty":false,"closeOnSelect":false},model:{value:(_vm.billing.memberFaoNames),callback:function ($$v) {_vm.$set(_vm.billing, "memberFaoNames", $$v)},expression:"billing.memberFaoNames"}}),_vm._v(" "),_c('label',{attrs:{"for":"billing-members"}},[_vm._v("Select Members")])],1)]),_vm._v(" "),_c('div',{staticClass:"billing-about-section materialized col-lg-5 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group materialized"},[_c('date-range',{attrs:{"initialStartDate":_vm.testNewDate(),"initialEndDate":new Date()},on:{"input":_vm.dateRangeChanged}}),_vm._v(" "),_c('label',{attrs:{"for":"billing-period"}},[_vm._v("Select Period")]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary date-range-go",attrs:{"type":"button","value":"GO","disabled":_vm.dateErrors.length > 0},on:{"click":function($event){_vm.searchByDateRangeUi(false)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.dateErrors.length > 0),expression:"dateErrors.length > 0"}],staticClass:"general-error-text"},[_vm._v(_vm._s(_vm.dateErrors[0]))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-1 col-md-1 col-sm-2 col-xs-12 hidden-xs hidden-sm pull-right materialized"},[_c('button',{staticClass:"btn btn-default btn-print",attrs:{"id":"billing-print","disabled":_vm.isPrinting || _vm.filteredRows.length === 0},on:{"click":function($event){_vm.printBilling()}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPrinting),expression:"isPrinting"}],staticClass:"fa fa-cog fa-spin fa-fw margin-bottom security-saving-icon"}),_vm._v(" "),_c('i',{staticClass:"fa fa-print"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"container billing-container"},[_c('div',{staticClass:"row billing-section"},[_c('div',{staticClass:"col-sm-12 materialized",attrs:{"id":"billing-history-table"}},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.filteredRows,"paginate":true,"rowsPerPageText":_vm.billing.rowsPerPageText,"showPageNumberForMobile":true,"showFootText":true,"footLabel":_vm.tfooter.label,"footValue":_vm.totalValue,"nextText":_vm.billing.nextText,"prevText":_vm.billing.prevText,"styleClass":"table condensed table-hover"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('td',{staticClass:"text-left-bh"},[_c('span',{staticClass:"data-item"},[(props.row.memberNumber === _vm.memberNumber)?_c('i',{staticClass:"fa fa-star"}):_vm._e(),_vm._v("\n              "+_vm._s(props.row.memberName)+"\n            ")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.date))])]),_vm._v(" "),_c('td',{staticClass:"text-center-bh hidden-xs-bh"},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.agreement))])]),_vm._v(" "),_c('td',{staticClass:"text-center hidden-xs-bh"},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.referenceNumber))])]),_vm._v(" "),_c('td',{staticClass:"text-center-bh"},[_c('span',{staticClass:"data-item",class:{'payment-done-color': props.row.numericBalance < 0}},[_vm._v(_vm._s(props.row.description))])]),_vm._v(" "),_c('td',{staticClass:"text-right-bh"},[_c('span',{staticClass:"data-item brand-24-green",class:{'payment-done-color': props.row.numericBalance < 0}},[_vm._v(_vm._s('$' + props.row.numericBalance.toFixed(2)))])]),_vm._v(" "),_c('td',{staticClass:"hidden-sm-bh"},[(props.row.numericBalance < 0)?_c('span',[_vm._v("Paid")]):_vm._e(),_vm._v(" "),(props.row.numericBalance > 0)?_c('span',[_vm._v("Unpaid")]):_vm._e()])]}}])},[_c('template',{attrs:{"slot":"table-under-banner"},slot:"table-under-banner"},[(_vm.filteredRows.length === 0 && !_vm.showSpinner)?_c('alert-banner',{attrs:{"alertMessage":'There is no account activity for the date range provided.'}}):_vm._e()],1)],2),_vm._v(" "),_c('div',{staticClass:"table-footer clearfix bh-table-footer bh-table-mobile-footer"},[_c('div',[_c('span',{staticClass:"tfoot-text-bh"},[_vm._v("Unpaid Balance:")]),_vm._v(" "),_c('span',{staticClass:"pull-right tfoot-text-bh"},[_vm._v(_vm._s(_vm.totalValue))])])]),_vm._v(" "),_vm._m(1)],1)])]),_vm._v(" "),_c('div',{staticClass:"container billing-container"},[_c('div',{staticClass:"row billing-section bottom-cta-button"},[_c('div',{staticClass:"col-md-12 materialized make-payment-container"},[_c('router-link',{attrs:{"to":{name: 'MakeAPayment'}}},[_c('button',{staticClass:"btn btn-primary pull-right",attrs:{"id":"billing-payment"}},[_vm._v("Make a Payment")])])],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container billing-container"},[_c('div',{staticClass:"row billing-section"},[_c('section',{staticClass:"col-sm-12 billing-desc-header"},[_c('h3',{staticClass:"title-24"},[_vm._v("Your Billing History")]),_vm._v(" "),_c('section',{staticClass:"card-24"},[_c('div',{staticClass:"card-text-container col-sm-12"},[_c('div',{staticClass:"text-24"},[_c('p',[_vm._v("\n                View past charges and payments, as well as any unpaid balance on your account.\n              ")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"primary-member-legend"},[_c('i',{staticClass:"fa fa-star"}),_vm._v(" Primary Member\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/BillingHistory.js